import Weather from "./Weather";
import Coder from "./Coder";

export default function App() {
  return (
    <div className="App">
      <div className="App">
        <Weather city="Tokyo" />
        <Coder />
      </div>
    </div>
  );
}
